import type { IPagination } from "../../../../types/models/pagination.models.types";
import type { ISocial } from "../../../../types/models/social.models.types";
import { useGetHttp } from "../../http.hook";

interface IResponse {
  socials: Array<ISocial>;
  pagination: IPagination;
}

export function useGetSocialsAdminHttp() {
  return useGetHttp<IResponse>({
    path: "/admin/socials",
  });
}
